import type { MonthlyIncomeRecord } from '@/modules/projects'
import type { IncomeChartData, IncomeTableRow } from './types'

export function toChartData(
  monthlyIncome: MonthlyIncomeRecord[],
): IncomeChartData[] {
  return monthlyIncome.map((record) => {
    const date = new Date(record.year, record.month - 1)
    return {
      date: date.toISOString(),
      income: record.totalIncome,
    }
  })
}

export function toTableData(
  monthlyIncome: MonthlyIncomeRecord[],
): IncomeTableRow[] {
  return monthlyIncome.map((record, index) => {
    const date = new Date(record.year, record.month - 1)
    const monthLabel = date.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    })
    const previousIncome =
      index > 0 ? monthlyIncome[index - 1].totalIncome : null
    const change =
      previousIncome !== null && previousIncome !== 0
        ? ((record.totalIncome - previousIncome) / previousIncome) * 100
        : null

    return {
      id: `${record.year}-${record.month}`,
      month: monthLabel,
      income: record.totalIncome,
      incomeFromOutside: record.incomeFromOutside,
      incomeBetweenProjectAccounts: record.incomeBetweenProjectAccounts,
      change,
    }
  })
}
